import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import clone from "../utils/clone";
import urlencoded from "../utils/urlencoded";
import { ACT_PROTOCOL } from "../constants/conf";
import { v4 } from 'uuid';
export var StrategyDefaultSettings = {
  useHttps: true,
  useRetry: true,
  retryTimes: 1,
  maxRequest: 5
};
var Strategy = /*#__PURE__*/function () {
  function Strategy() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StrategyDefaultSettings;
    var initialData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Strategy);
    this.configure(options);
    this.override(initialData);
  }

  /**
   * 重写配置
   * @param options 配置
   */
  _createClass(Strategy, [{
    key: "configure",
    value: function configure(options) {
      var _window$location, _window$location$prot;
      var finaloptions = Object.assign({}, this.options, clone(options));
      if (!(0 < finaloptions.retryTimes && finaloptions.retryTimes < 4)) {
        finaloptions.retryTimes = 1;
      }
      if (((_window$location = window.location) === null || _window$location === void 0 ? void 0 : (_window$location$prot = _window$location.protocol) === null || _window$location$prot === void 0 ? void 0 : _window$location$prot.indexOf('https')) !== -1) {
        finaloptions.useHttps = true;
      }
      this.options = finaloptions;
    }

    /**
     * 合并数据
     * @param data 提交的数据
     */
  }, {
    key: "merge",
    value: function merge(data) {
      this.data = Object.assign({}, this.data, data);
    }

    /**
     * 重写数据
     * @param data 提交的数据
     */
  }, {
    key: "override",
    value: function override(data) {
      this.data = clone(data);
    }

    /**
     * 注册拦截器
     * @param type 类型
     * @param interceptor 请求的拦截器
     */
  }, {
    key: "use",
    value: function use(type, interceptor) {
      if (typeof interceptor === 'function') {
        switch (type) {
          case 'url':
            this.urlInterceptor = interceptor;
            break;
          case 'request':
            this.requestInterceptor = interceptor;
            break;
        }
      }
    }

    /**
     * 编码跟踪数据
     * @param trackingData 跟踪数据
     */
  }, {
    key: "processTrackingData",
    value: function processTrackingData(trackingData) {
      var initialData = Object.assign({}, this.data, trackingData);
      var completed = this.completeTrackingData(initialData);
      return this.pretreateTrackingData(completed);
    }
  }, {
    key: "encodeTrackingData",
    value: function encodeTrackingData(trackingData) {
      var formated = this.formatTrackingData(trackingData);
      var encoded = urlencoded(formated);
      return encoded;
    }

    /**
     * 补全跟踪数据
     * @param partialTrackingData 部分跟踪数据
     */
  }, {
    key: "completeTrackingData",
    value: function completeTrackingData(partialTrackingData) {
      var _window, _window$location2, _window2, _window2$location, _window3, _window3$navigator, _document;
      var METADATA = {
        act: ACT_PROTOCOL,
        time: Math.floor(new Date().getTime() / 1000),
        domain: (_window = window) === null || _window === void 0 ? void 0 : (_window$location2 = _window.location) === null || _window$location2 === void 0 ? void 0 : _window$location2.hostname,
        url: (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href,
        ua: (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : _window3$navigator.userAgent,
        ref: (_document = document) === null || _document === void 0 ? void 0 : _document.referrer,
        data_id: v4(),
        request_time: Date.now()
      };
      return Object.assign({}, METADATA, partialTrackingData);
    }
  }, {
    key: "formatMoreInfoData",
    value: function formatMoreInfoData(moreInfo) {
      var _window4;
      var MOREINFO = {
        language: (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.navigator.language,
        is_mobile: this.getIsMobile()
      };
      return Object.assign({}, MOREINFO, moreInfo);
    }
  }, {
    key: "getMobile",
    value: function getMobile() {
      var _window5;
      var ua = (_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.navigator.userAgent;
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
      var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
      var isMobile = isIphone || isAndroid;
      return isMobile;
    }
  }, {
    key: "getIsMobile",
    value: function getIsMobile() {
      return this.getMobile() ? '101' : '102';
    }

    /**
     * 数据预处理
     * @param trackingData 跟踪数据
     */
  }, {
    key: "pretreateTrackingData",
    value: function pretreateTrackingData(trackingData) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;
      var request = this.requestInterceptor;
      if (typeof request === 'function') {
        return request(trackingData, options);
      }
      return trackingData;
    }

    /**
     * 格式化并校验数据
     * @param trackingData 跟踪数据
     */
  }, {
    key: "formatTrackingData",
    value: function formatTrackingData(trackingData) {
      var cloned = clone(trackingData);
      if (!cloned.moreinfo) {
        cloned.moreinfo = {};
      }
      if (_typeof(cloned.moreinfo) === 'object') {
        cloned.moreinfo = this.formatMoreInfoData(cloned.moreinfo);
        cloned.moreinfo = JSON.stringify(cloned.moreinfo);
      }
      if (cloned.domain === 'localhost') {
        cloned.domain = '';
      }
      return cloned;
    }
  }, {
    key: "destory",
    value: function destory() {
      this.data = undefined;
      this.options = undefined;
      this.urlInterceptor = undefined;
      this.requestInterceptor = undefined;
    }
  }]);
  return Strategy;
}();
export { Strategy as default };